import {
	btn,
	Button,
	checkbox,
	comp,
	Component,
	Config,
	containerfield,
	cookies,
	datefield,
	DateTime,
	fieldset,
	form,
	Notifier,
	textfield,
	TextField
} from "@intermesh/goui";
import {CurrentParticipant} from "../services/CurrentParticipant.js";
import {ParticipantEntity} from "../data/ParticipantsStore.js";
import {t} from "../util/Translate.js";
import {ServerApi} from "../util/ServerApi.js";
import {IfwInvalidator} from "../util/IfwInvalidator.js";
import {renderCustomFieldForm} from "./CustomField";

export class RegistrationForm extends Component {
	[x: string]: any;

	public readonly form;

	public currentParticipant: ParticipantEntity | undefined;

	public usernameFld: TextField;
	public passwordFld: TextField;
	public emailFld: TextField;
	private passwordRepeatFld: TextField;

	private minAge: number | undefined;
	private minAgeWarning: Component;

	private mustCreateLogin = true;

	constructor(public readOnly: boolean = false) {
		const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);
		super();
		const fs = fieldset({},
			comp({
					tagName: "div"
				},
				comp({
					tagName: "h3",
					text: this.readOnly ? t("Please confirm") : t("Please enter your details")
				}),
				comp({
					tagName: "h4",
					text: t("Please confirm your input in the form below"),
					hidden: !this.readOnly
				}),
			),
			comp({
					cls: "row",
				},
				textfield({
					flex: 1,
					label: t("First name"),
					id: "firstName",
					name: "firstName",
					required: true,
					readOnly: this.readOnly,
					icon: "person",
					listeners: {
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}
				}),
				textfield({
					flex: 1,
					label: t("Middle name"),
					name: "middleName",
					id: "middleName",
					required: false,
					readOnly: this.readOnly

				}),
				textfield({
					flex: 1,
					label: t("Last name"),
					id: "lastName",
					name: "lastName",
					required: true,
					readOnly: this.readOnly,
					listeners: {
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}

				})
			),
			comp({cls: "row"},
				datefield({
					label: t("Date of birth"),
					id: "dateOfBirth",
					name: "dateOfBirth",
					cls: "with-icon",
					icon: "cake",
					required: true,
					readOnly: this.readOnly,
					// maxDate: new DateTime(), // today
					max: new DateTime(), // today
					listeners: {
						invalid: IfwInvalidator.setTranslatedDateErrorMsg,
						change: ({newValue}) => {
							this.minAgeWarning.hide();
							if (!this.minAge) {
								return true;
							}
							const now = new DateTime(), date = new DateTime(newValue);
							now.setHours(0).setMinutes(0).setSeconds(0).setMilliseconds(0).addYears((0 - this.minAge));
							if (date.compare(now) > 0) {
								this.minAgeWarning!.findChild("minAgeWarnText")!.text =
									t("Warning: On most of our locations, a minimum age of {age} years is set to be allowed to enter. Please check with your contact person.")
										.replace("{age}", this.minAge);
								this.minAgeWarning.show();
							}
						}
					}
				}),
				this.minAgeWarning = comp({cls: "hbox", flex: 1, hidden: true},
					btn({
						cls: "go-elearning-incident", icon: "warning", handler: () => {
						}, style: {paddingLeft: "2px", paddingRight: "8px"}
					}),
					comp({
						flex: 1, tagName: "p", id: "minAgeWarnText",
						text: ""
					})
				)),

			containerfield({name: "user"},
				this.usernameFld = textfield({
					label: t("Username"),
					name: "username",
					id: "username",
					cls: "with-icon",
					icon: "account_circle",

					readOnly: this.readOnly,
					hidden: !this.mustCreateLogin,
					disabled: !this.mustCreateLogin,
					required: this.mustCreateLogin,
					listeners: {
						change: async ({target, newValue}) => {
							ServerApi.call("elearning/frontend/participants/checkUserName", {userName: newValue}, "POST")
								.then((result) => {
									if (result.success) {
										if (result.userName) {
											target.value = result.userName;
										}
									} else {
										target.setInvalid(t("Sorry, this username is already taken"));
									}
								});
						}
					}
				}),

				comp({cls: "row"},
					this.passwordFld = textfield({
						type: "password",
						label: t("Password"),
						name: "password",
						id: "password",
						flex: 1,
						icon: "lock",
						readOnly: this.readOnly,
						hidden: !this.mustCreateLogin,
						disabled: !this.mustCreateLogin,
						required: this.mustCreateLogin,
						listeners: {
							invalid: IfwInvalidator.setTranslatedErrorMsg
						}

					}),
					this.passwordRepeatFld = textfield({
						type: "password",
						label: t("Repeat Password"),
						name: "passwordRepeat",
						id: "passwordRepeat",
						icon: "lock",
						flex: 1,
						readOnly: this.readOnly,
						hidden: !this.mustCreateLogin,
						disabled: !this.mustCreateLogin,
						required: this.mustCreateLogin,
						listeners: {
							change: ({target, newValue}) => {
								const dupe = this.passwordFld.value;
								if (dupe && dupe !== newValue) {
									target.setInvalid(t("The passwords don't match"))
								}
							},
							invalid: IfwInvalidator.setTranslatedErrorMsg
						},
						buttons: [
							this.togglepasswdBtn = btn({
								icon: "visibility", cls: "danger", handler: (btn: Button) => {
									const pi = this.passwordFld.input,
										pri = this.passwordRepeatFld.input;
									if (pi!.type === "password") {
										pi!.type = "text";
										pri!.type = "text";

										btn.icon = "visibility_off";
									} else {
										pi!.type = "password";
										pri!.type = "password";

										btn.icon = "visibility";
									}

								}, disabled: this.readOnly
							})
						]
					}),
				)
			),

			textfield({
				label: t("Company"),
				name: "company",
				required: portalConfig.participant.requireCompany,
				readOnly: this.readOnly,
				icon: "domain"
			}),

			this.emailFld = textfield({
				label: t("Email"),
				name: "email",
				type: "email",
				required: portalConfig.participant.requireEmail,
				readOnly: this.readOnly,
				hint: t("Your e-mail address will only be used for creating your account and to send your certificate and reminders."),
				icon: "email",
				listeners: {
					invalid: IfwInvalidator.setTranslatedEmailErrorMsg
				}
			}),


			checkbox({
				name: "remindMe",
				id: "remindMe",
				label: t("Remind me by e-mail when my certificates are about to expire"),
				hidden: portalConfig.isEmployee,
				listeners: {
					change: ({newValue}) => {
						this.form.findField("email")!.required = newValue;
					}
				},
				disabled: this.readOnly
			})
		);

		this.form = form({
			handler: async () => {
				return await this.save();
			}
		}, fs);

		this.items.add(this.form);

	}


	async save() {
		Object.assign(this.currentParticipant!, this.form.value);
		sessionStorage.setItem("currentParticipant", JSON.stringify(this.currentParticipant));
	}

	async load() {
		try {
			super.mask();
			await this.setPreconditions();

			this.currentParticipant = await CurrentParticipant.readIf();
			if (this.currentParticipant) {
				if (this.currentParticipant.id) {
					this.mustCreateLogin = false;
				}

				const cfContainer = await renderCustomFieldForm(this.currentParticipant, true, this.readOnly);
				this.form.items.add(cfContainer);

				this.form.value = this.currentParticipant;
				if (!this.currentParticipant.id) {
					const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);
					this.form.findField("remindMe")!.value = portalConfig.enableRemindersByDefault;
				}
			}
		} catch (error: any) {
			Notifier.error(error);
		} finally {
			super.unmask();
		}
	}

	/**
	 * Set parameters for several use cases.
	 *
	 * @private
	 */

	private async setPreconditions() {
		const configUrl = ServerApi.url("elearning/configuration/1");
		const elearningConfig = await ServerApi.call(configUrl, {}, "GET");


		this.minAge = elearningConfig.data.minimumAgeOfParticipants;
		const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);
		if (portalConfig.doGenerateCredentials && cookies.get("sectionAuth")) {
			this.mustCreateLogin = false;
		}
		this.passwordFld.hint = t(portalConfig.activePasswordRuleSet + "RuleSetText");

	}
}

export const registrationForm = (config?: Config<RegistrationForm>) => Object.assign(new RegistrationForm(config?.readOnly), config);